import React, { Component } from 'react'
import styled from 'styled-components'
import Skills from './skills.js'
import Modal from 'react-modal'
import { searchCategories } from '../../func/skills.js'

import Icon from './icon_search.svg'

const Wrapper = styled.div`
  width: ${({ mediaQuery }) => (mediaQuery === 'smartphone' ? '100%' : '25%')};
  max-width: 287px;
  height: calc(${window.innerHeight}px - (${window.innerHeight}px / 10));
  background-color: #fff;
  border-right: 2px solid rgb(233, 233, 233);
  padding: 0 0 0 2vw;
  margin: ${({ mediaQuery }) => (mediaQuery === 'smartphone' ? '0 auto' : '0')};
  ${'' /* margin-top: 2.5vh; */}
  position: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone' ? 'fixed' : 'relative'};
  left: ${({ mediaQuery, displaySearch }) =>
    mediaQuery === 'smartphone' ? (displaySearch ? '0' : '-100vw') : '0'};
  right: ${({ mediaQuery, displaySearch }) =>
    mediaQuery === 'smartphone' ? (displaySearch ? '0' : '100vw') : 'auto'};
  top: ${({ mediaQuery }) => (mediaQuery === 'smartphone' ? '10vh' : '0')};
  transition:
    left 1s ease,
    opacity 1s ease,
    right 1s ease;
  z-index: ${({ mediaQuery }) => (mediaQuery === 'smartphone' ? '999' : '2')};
  opacity: ${({ mediaQuery, displaySearch }) =>
    mediaQuery === 'smartphone' ? (displaySearch ? '1' : '0') : '1'};
  overflow-y: scroll;
  & > * {
    z-index: 999;
  }
  &::before {
    content: '';
    background: #fff;
    display: ${({ mediaQuery }) =>
      mediaQuery === 'smartphone' ? 'initial' : 'none'};
    left: ${({ mediaQuery, displaySearch }) =>
      mediaQuery === 'smartphone' ? (displaySearch ? '0' : '-100%') : '0'};
    transition: left 1s ease;
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    z-index: -1;
  }
`

const SearchTitle = styled.div`
  font-size: 12px;
  color: rgb(79, 79, 79);
  font-weight: bold;
  margin: 10px 0;
  text-decoration: underline;
`

const InputSearch = styled.input`
  height: 20px;
  width: calc(90% - 34px);
  padding: 10px 0 10px 34px;
  font-weight: bold;
  background-color: rgb(233, 233, 233);
  color: rgb(79, 79, 79);
  font-size: 16px;
  border-radius: 5px;
  border: none;
  outline: none;
  transition:
    padding 0.2s ease,
    width 0.2s ease;

  &::placeholder {
    opacity: ${({ focus }) => (focus ? 0 : 1)};
    transition: opacity 0.2s ease;
  }

  &:focus {
    padding: 10px 0 10px 10px;
    width: calc(80% + 24px);
  }
`

const CloseIcon = styled.div`
  width: 10vh;
  height: 10vh;
  background: url('/assets/svg/close.svg');
  position: absolute;
  right: 0px;
  left: 0;
  margin: auto;
  top: 2px;
  z-index: 9999999;
`

const ResultNumber = styled.div`
  font-size: 15px;
  color: rgb(159, 156, 156);
  padding: 10px 0;
  font-weight: bold;
`

const ButtonMap = styled.div`
  border-radius: 5px;
  padding: 10px 0 10px 15px;
  margin-top: 15px;
  font-weight: bold;
  background-color: rgb(233, 233, 233);
  color: rgb(117, 114, 114);
  cursor: pointer;
  font-size: 13px;
  width: calc(90% - 15px);
`

const Submit = styled.button`
  max-width: 330px;
  height: 40px;
  min-height: 40px;
  font-size: 15px;
  border-radius: 5px;
  background: rgb(70, 144, 255);
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  &:active {
    background-color: rgb(51, 107, 190);
    color: rgb(191, 191, 191);
  }
`

const SearchIcon = styled.span`
  position: relative;
  &::before {
    position: absolute;
    content: url(${Icon});
    padding: 13px 10px;
    width: 14px;
    height: 14px;
    opacity: ${({ focus }) => (focus ? 0 : 1)};
    transition: opacity 0.2s ease;
  }
`

const EraseIcon = styled.div`
  background: url('assets/svg/close.svg');
  background-position: center;
  background-size: contain;
  cursor: pointer;
  background-repeat: no-repeat;
  width: 35px;
  height: 35px;
  position: absolute;
  opacity: ${({ focus }) => (focus ? 1 : 0)};
  transition: opacity 0.2s ease;
  right: 2px;
  top: 0;
  bottom: 0;
  margin: auto 0;
`

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: '99999',
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      height: '70vh',
      overflow: 'scroll',
    },
  },
}

class Search extends Component {
  constructor() {
    super()
    this.state = {
      focus: false,
    }
  }
  render() {
    return (
      <Wrapper
        mediaQuery={this.props.mediaQuery}
        displaySearch={this.props.displaySearch}
      >
        <SearchTitle>Recherche par nom, média, mot clé… :</SearchTitle>
        <SearchIcon focus={this.state.focus}>
          <InputSearch
            placeholder="Rechercher"
            focus={this.state.focus}
            onFocus={() => {
              this.setState({ focus: true })
            }}
            onBlur={() => {
              this.setState({ focus: false })
            }}
            onChange={this.props.onChange.bind(this)}
            value={this.props.searchTerm}
            onKeyDown={(e) => {
              var code = e.keyCode ? e.keyCode : e.which
              if (code === 13) {
                this.props.findMatches()
              }
            }}
          />
          <EraseIcon
            focus={this.state.focus}
            onClick={this.props.eraseSearch}
          />
        </SearchIcon>
        <ResultNumber>Resultats: {this.props.number}</ResultNumber>
        <Submit onClick={this.props.findMatches}>Rechercher</Submit>
        <SearchTitle>Recherche par domaines d’expertise :</SearchTitle>
        <Skills
          handleSkillClick={(skill) => this.props.handleSkillClick(skill)}
          categories={searchCategories}
        />
        {/* <SearchTitle>Recherche par localisation :</SearchTitle> */}
        {/* <ButtonMap
          onClick={() => {
            this.setState({ mapOpen: true })
            this.props.mediaQuery === 'smartphone'
              ? this.props.toggleSearch()
              : ''
          }}
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
        >
          Carte de nos membres
        </ButtonMap> */}
        <Modal isOpen={this.state.mapOpen} style={customStyles}>
          <CloseIcon onClick={() => this.setState({ mapOpen: false })} />
          <iframe
            src="https://www.google.com/maps/d/u/3/embed?mid=1qk3Ndssj7AmYde0GSYQGD3EC8eG8VMsq"
            style={{
              width: '90%',
              position: 'absolute',
              left: 0,
              right: 0,
              top: '10vh',
              margin: 'auto',
              height: '90%',
            }}
          />
        </Modal>
      </Wrapper>
    )
  }
}

export default Search



// WEBPACK FOOTER //
// ./src/components/search/index.js